(() => {
  function ensureModal() {
    let modal = document.getElementById('lk-zoom-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'lk-zoom-modal';
    modal.id = 'lk-zoom-modal';
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="lk-zoom-card" role="dialog" aria-modal="true" aria-label="Image">
        <div class="lk-zoom-bar">
          <div class="lk-zoom-hint">Esc = close</div>
          <div class="lk-zoom-actions">
            <button type="button" class="lk-zoom-btn" data-lk-zoom-close aria-label="Close">✕</button>
          </div>
        </div>
        <div class="lk-zoom-stage">
          <img class="lk-zoom-img" data-lk-zoom-img alt="" width="1600" height="1200">
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    return modal;
  }

  const modal = ensureModal();
  const img = modal.querySelector('[data-lk-zoom-img]');
  const btnClose = modal.querySelector('[data-lk-zoom-close]');

  function open(src, altText) {
    img.alt = altText || 'Review image';
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    img.src = src;
  }

  function close() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    img.removeAttribute('src');
    document.documentElement.style.overflow = '';
  }

  // open (works for injected content)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.lk-zoom-thumb');
    if (!btn) return;

    const src = btn.getAttribute('data-lk-zoom-src');
    if (!src) return;

    e.preventDefault();
    const thumbImg = btn.querySelector('img');
    const alt = thumbImg?.getAttribute('alt') || 'Review image';
    open(src, alt);
  }, true);

  // close button
  btnClose?.addEventListener('click', close);

  // close on backdrop click (not when clicking the card)
  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });

  // esc closes
  document.addEventListener('keydown', (e) => {
    if (!modal.hidden && e.key === 'Escape') close();
  });
})();
